export const EmailVerificationController = {
    send(): void {},
    check(): void {},
};
